module.exports = __webpack_public_path__ + "static/img/workPass2.97e0a837.png";